export const DeviceStatesEnum = {
  ATTIVATO: 'ATTIVATO',
  DISATTIVATO: 'DISATTIVATO',
  DISMESSO: 'DISMESSO',
}
